<button
  *ngIf="visible"
  tuiButton
  class="report-button"
  type="button"
  [appearance]="'secondary'"
  [size]="size"
  (click)="showReportsDialog(reportsTmp)"
>
  {{ 'common.buttons.reports' | translate }}
</button>

<ng-template #reportsTmp>
  <app-reports [reportType]="reportType" [hiddenReportData]="hiddenReportData"></app-reports>
</ng-template>
